import React from 'react';
import { SortAsc, Filter } from 'lucide-react';

const SortFilterControls = ({ sortBy, setSortBy, filterBy, setFilterBy }) => {
  const sortOptions = [
    { key: 'price', label: 'Price' },
    { key: 'rating', label: 'Rating' },
    { key: 'timeline', label: 'Timeline' },
  ];

  const filterOptions = [
    { key: 'all', label: 'All Bids' },
    { key: 'premium', label: 'Premium' },
    { key: 'budget', label: 'Budget' },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-sm p-6 mb-8 border border-gray-100">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center space-x-2">
          <SortAsc className="w-5 h-5 text-gray-400" />
          <span className="text-sm font-medium text-gray-700">Sort by:</span>
          <div className="flex space-x-2">
            {sortOptions.map((option) => (
              <button
                key={option.key}
                data-testid={`sort-${option.key}`}
                onClick={() => setSortBy(option.key)}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                  sortBy === option.key
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Filter className="w-5 h-5 text-gray-400" />
          <span className="text-sm font-medium text-gray-700">Filter:</span>
          <div className="flex space-x-2">
            {filterOptions.map((option) => (
              <button
                key={option.key}
                data-testid={`filter-${option.key}`}
                onClick={() => setFilterBy(option.key)}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                  filterBy === option.key
                    ? 'bg-emerald-600 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortFilterControls;
